import script from "./Eula.vue?vue&type=script&setup=true&lang=js"
export * from "./Eula.vue?vue&type=script&setup=true&lang=js"

import "./Eula.vue?vue&type=style&index=0&id=843a88ba&lang=css"

const __exports__ = script;

export default __exports__